import {l} from "types/typescriptdefinisjoner_lederplan";
import {Kontekst} from "../Kontekst";
import {TilgangsrolleMedlem} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";


export class OppgaveTjeneste {

    static regNavn = "oppgaveTjeneste";

    static forInjisering() {
        return [Kontekst.regNavn, OppgaveTjeneste]
    }

    constructor(private kontekst: Kontekst) {
    }

    /*
    Brukes for å avgjøre om rediger/slett knapp på oppgave kan vises
    */
    kanOppgaveRedigeres(oppgave: l.OppgaveModell): boolean {
        if (oppgave.ansvarlig != null) {
            if (oppgave.ansvarlig.brukerId === this.kontekst.autentisertBrukersId())
                return true;
        }
        return this.kontekst.inneharTilgangsrolleIGruppe(l.TilgangsrolleMedlem.skrive, oppgave.eiendeGruppeId);
    }
}
